import React from 'react';
import {
  CopyBlock,
  CopyBlockAlignment,
  CopyBlockProps,
} from '@noths/polaris-client-ribbons-design-system';
import parse from 'html-react-parser';

import { trackLinkClick } from 'src/tracking/components/copyBlock';
import { TrackingContext } from 'src/types/TrackingContext';
import { trackImpression } from '../../../tracking/common/trackImpression';
import { SectionContainer } from '../../molecules/SectionContainer/SectionContainer';
import * as styles from './CopyBlockSection.style';

export interface CopyBlockSectionProps extends CopyBlockProps {
  children: string;
  trackingTitle: string;
  trackingPosition?: number;
}

export const CopyBlockSection = ({
  alignment,
  children,
  trackingPosition,
  trackingTitle,
}: CopyBlockSectionProps) => {
  const trackingContext: TrackingContext = {
    trackingPosition,
    trackingTitle,
    trackingContentType: 'Copy block',
  };

  return (
    <SectionContainer wrapperStyles={styles.wrapper} maxWidth="full" columnsL={8}>
      <CopyBlock
        alignment={alignment}
        onLinkClick={(e: React.MouseEvent) => trackLinkClick(e, trackingContext)}
        onVisible={() => trackImpression(trackingContext)}
      >
        {parse(children)}
      </CopyBlock>
    </SectionContainer>
  );
};

export type { CopyBlockProps, CopyBlockAlignment };
